var _g, _circle, _circle2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestDetailsNonActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_3891_84789)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 43,
    fill: "#949292",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 43,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 39,
    fill: "#949292"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9163 31.167C79.0209 31.167 79.9163 32.0624 79.9163 33.167V69.8337C79.9163 70.9382 79.0209 71.8337 77.9163 71.8337H31.083C29.9784 71.8337 29.083 70.9382 29.083 69.8337V33.167C29.083 32.0624 29.9784 31.167 31.083 31.167H77.9163ZM72.2913 58.4899C72.2913 57.4371 71.4379 56.5837 70.3851 56.5837H58.9476C57.8948 56.5837 57.0413 57.4371 57.0413 58.4899V58.4899C57.0413 59.5427 57.8948 60.3962 58.9476 60.3962H70.3851C71.4379 60.3962 72.2913 59.5427 72.2913 58.4899V58.4899ZM44.0153 49.7212H42.109C39.0886 49.7212 36.537 51.7705 35.715 54.6093C35.4079 55.6703 36.3326 56.5837 37.4372 56.5837H48.6872C49.7917 56.5837 50.7164 55.6702 50.4084 54.6095C49.5839 51.7706 47.0259 49.7212 44.0153 49.7212ZM72.2913 50.8649C72.2913 49.8121 71.4379 48.9587 70.3851 48.9587H58.9476C57.8948 48.9587 57.0413 49.8121 57.0413 50.8649V50.8649C57.0413 51.9177 57.8948 52.7712 58.9476 52.7712H70.3851C71.4379 52.7712 72.2913 51.9177 72.2913 50.8649V50.8649ZM43.0622 40.5346C41.2198 40.5346 39.7262 42.0281 39.7262 43.8705C39.7262 45.7129 41.2198 47.2064 43.0622 47.2064C44.9046 47.2064 46.3981 45.7129 46.3981 43.8705C46.3981 42.0281 44.9046 40.5346 43.0622 40.5346ZM72.2913 43.2399C72.2913 42.1871 71.4379 41.3337 70.3851 41.3337H58.9476C57.8948 41.3337 57.0413 42.1871 57.0413 43.2399V43.2399C57.0413 44.2927 57.8948 45.1462 58.9476 45.1462H70.3851C71.4379 45.1462 72.2913 44.2927 72.2913 43.2399V43.2399Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_3891_84789",
    x: 0,
    y: 0,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3891_84789"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3891_84789"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3891_84789",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect2_foregroundBlur_3891_84789"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestDetailsNonActive);
export default __webpack_public_path__ + "static/media/RequestDetailsNonActive.f72a9cbea28dd9719b7f6787d19faa32.svg";
export { ForwardRef as ReactComponent };